import { DeepPartial, DeepReadonly } from 'ts-essentials';
import {
    ElementCommonPropertyConverter,
} from '@src/slide/domain/ui-model/converter/node-property/element/element-common-property-converter';
import { DeltaOf, IChartData, IChartProps } from '@tencent/slide-sdk-model';
import {
    ChartConverter,
} from '@src/slide/domain/ui-model/converter/node-property/module-property/chart/chart-converter';
import { IChartModel } from '@src/slide/domain/ui-model/element-modeles/Interface/chart-v3/chart-model.interface';

export class ChartPropertyConverter {
    public static convertPartialDataFromSdkToUi(
        sdkData: DeepReadonly<DeepPartial<IChartProps>>,
        uiData: IChartModel,
    ): void {
        // **** 公共属性 ****

        // frame
        ElementCommonPropertyConverter.convertPartialDataFromSdkToUi(sdkData, uiData);

        // **** 独有属性 ****
        ChartConverter.convertPartialDataFromSdkToUi(sdkData, uiData);
    }

    public static convertPartialDataFromUiToSdk(
        uiData: DeepPartial<IChartModel>,
        sdkData: DeltaOf<IChartData>,
        rawUiData: IChartModel,
    ): void {
        // **** 公共属性 ****

        // frame
        ElementCommonPropertyConverter.convertPartialDataFromUiToSdk(uiData, sdkData, rawUiData);

        // **** 独有属性 ****
        ChartConverter.convertPartialDataFromUiToSdk(uiData, sdkData);
    }
}
